import { render, staticRenderFns } from "./CategoryInclude.vue?vue&type=template&id=0b2642b6&"
import script from "./CategoryInclude.vue?vue&type=script&lang=js&"
export * from "./CategoryInclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports